/**
 * Optional QA/demo prefill for the partner registration form.
 * Enable only in local/staging: REACT_APP_PREFILL_PARTNER_DEMO=true
 */
export function isPartnerFormDemoPrefillEnabled() {
  return (
    String(process.env.REACT_APP_PREFILL_PARTNER_DEMO || "")
      .toLowerCase()
      .trim() === "true"
  );
}

export function getPartnerDemoPrefillEmail() {
  const v = (process.env.REACT_APP_PREFILL_PARTNER_EMAIL || "").trim();
  return v || "moj@godocm.com";
}
